export const tr = {
    'copy-link': 'Koşul listesini kopyala',
    ots: 'OTS',
    'predictor-error': 'Tahmin geçici olarak geçersiz',
    'predictor-seven-days': '7 günlük kapsam tahmini',
    reach: 'Kapsam'
};
